// extracted by mini-css-extract-plugin
module.exports = {"lds-ellipsis":"style_lds-ellipsis__2ylft","lds-ellipsis1":"style_lds-ellipsis1__3K1el","lds-ellipsis2":"style_lds-ellipsis2__3kqaZ","lds-ellipsis3":"style_lds-ellipsis3__2dYpr"};